import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgLetModule } from '@shared/directives/ng-let/ng-let.module';
import { CarouselComponent } from './components/carousel/carousel.component';
import { CarouselSlideTemplateDirective } from './directives/carousel-slide-template.directive';

@NgModule({
  declarations: [CarouselComponent, CarouselSlideTemplateDirective],
  imports: [CommonModule, NgLetModule],
  exports: [CarouselComponent, CarouselSlideTemplateDirective]
})
export class CarouselModule {}
